// @ts-strict-ignore
import { IconChevronRightLarge } from "@hubble/icons";
import { Row } from "components/layout/Grid";

import styled from "styled-components";

export const DropdownContentContainer = styled.div`
  width: 100%;
  position: absolute;
  z-index: ${(props) => (props.index + 1) * 2};
  background-color: ${({ color }) => color && color};
`;

export const DropDownContainer = styled.div`
  cursor: pointer;
  min-height: 60px;
  width: 100%;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 0 1rem;
  background-color: ${({ theme }) => theme.backgroundColors.primary};
  z-index: ${({ index }) => index && index + 1};
  div {
    padding: 10px;
  }
  ${(props) =>
    props.active &&
    `border: 1px solid ${props.theme.borderColors.primary};
     border-radius: 8px;
  `}
`;

export const ActiveDropDownContainer = styled(DropDownContainer)`
  background-color: ${({ color }) => color && color} !important;
  div {
    border-left: 1px solid ${({ theme }) => theme.borderColors.primary};
    border-right: 1px solid ${({ theme }) => theme.borderColors.primary};
    &:hover {
      background-color: ${({ theme }) => theme.backgroundColors.secondary};
    }
    &:first-child {
      padding: 0 10px;
      display: flex;
      align-items: center;
      margin-bottom: 14px;
      border: 1px solid ${({ theme }) => theme.borderColors.primary};
      border-radius: 8px;
      height: 58px;
      ${(props) => props.theme.media.tablet`
        margin-bottom: 24px;
      `}
      &:hover {
        background-color: ${({ theme }) => theme.backgroundColors.primary};
      }
    }
    &:nth-child(2) {
      border-top: 1px solid ${({ theme }) => theme.borderColors.primary};
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    }
    &:last-child {
      border-bottom: 1px solid ${({ theme }) => theme.borderColors.primary};
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
    }
  }
`;

export const OptionsDropdownContainer = styled.div`
  width: 100%;
  position: relative;
`;

export const CaretIcon = styled(IconChevronRightLarge).attrs({ size: "sm" })`
  position: absolute;
  right: 20px;
  top: 45%;
  transform: rotate(90deg) translate(-45%);
  ${(props) =>
    props.active &&
    `
    top: unset;
    transform: rotate(270deg);
  `}
`;

export const DropdownRow = styled(Row)`
  position: relative;
  ${({ theme: { media } }) => media.tablet`
    display: flex;
    justify-content: center;
    margin-top: 64px;
    margin-bottom: 34px;
  `}
`;

export const Item = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.backgroundColors.primary};
`;
